import { HTMLThemeElement } from '@archetype-themes/custom-elements/theme-element';

class CareGuideProductRecommendations extends HTMLThemeElement {
  connectedCallback() {
    this.similarPlantsWrapperEl = this.querySelector(
      '.js-similar-plants-wrapper'
    );
    this.similarPlantsEl = this.querySelector('.js-similar-plants');
    this.productCategoryMappingsEl = this.querySelector(
      '[data-product-mappings-plants]'
    );

    this._fetchRecommendations();
  }

  _fetchRecommendations() {
    const recommendationsEl = this;

    const baseUrl = recommendationsEl.dataset.productRecommendationsUrl;
    const productId = recommendationsEl.dataset.productId;

    if (!baseUrl || !productId) {
      console.error('Product recommendations URL or Product ID is missing');
      return;
    }

    const requestUrl = `${baseUrl}.json?product_id=${productId}`;

    window
      .fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          console.error(
            'Failed to fetch recommendations:',
            response.statusText
          ); // Debugging
          return;
        }
        return response.json();
      })
      .then((data) => {
        if (data?.products?.length) {
          this._processProducts(data.products);
        } else {
          console.warn('No products found in the response');
        }
      })
      .catch((error) => {
        console.error('Error fetching recommendations:', error);
      });
  }

  _processProducts(products) {
    let filteredProducts = products;

    // Exclude products with specific tags ( keep this filter as fallback )
    const excludedTags = ['pot', 'pots & planters', 'pots'];
    filteredProducts = filteredProducts.filter(
      (product) => !product.tags.some((tag) => excludedTags.includes(tag))
    );

    if (this.productCategoryMappingsEl) {
      let plantTypes =
        this.productCategoryMappingsEl.dataset.productMappingsPlants;

      if (plantTypes) {
        plantTypes = plantTypes.split(',');

        filteredProducts = products.filter((product) =>
          plantTypes.includes(product.type)
        );
      }
    } else {
      console.warn('No product category mappings found');
    }

    // Limit the products to 4
    filteredProducts = filteredProducts.slice(0, 4);

    if (filteredProducts.length) {
      this._renderRecommendedProducts(filteredProducts);
    } else {
      console.warn('No products match the filter criteria');
    }
  }

  _renderRecommendedProducts(products) {
    // Clear the existing content in the similarPlantsEl
    this.similarPlantsEl.innerHTML = '';

    // Fetch and render each product using the 'product.grid-item' template
    const fetchProductView = (productHandle) => {
      return new Promise((resolve, reject) => {
        const url = `/products/${productHandle}?view=grid-item`;
        window
          .fetch(url, {
            method: 'GET',
          })
          .then((response) => {
            response
              .text()
              .then((text) => {
                resolve(text);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((err) => {
            console.error('Error fetching product view:', err);
          });
      });
    };

    // Create promises for fetching product views
    const promises = products.map((product) =>
      fetchProductView(product.handle)
    );

    // Render all fetched product views
    Promise.all(promises)
      .then((results) => {
        results.forEach((markup) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = markup;
          this.similarPlantsEl.appendChild(wrapper.firstElementChild);
        });

        // Unhide the wrapper
        this.similarPlantsWrapperEl.classList.remove('hidden');
      })
      .catch((err) => {
        console.error('Error rendering recommended products:', err);
      });
  }

  // Helper function to format the price
  _formatPrice(priceInCents) {
    const dollars = Math.floor(priceInCents / 100);
    const cents = (priceInCents % 100).toString().padStart(2, '0');
    return `
      <span aria-hidden="true" class="grid-product__price--from">
        <span>from</span> $${dollars}<sup>${cents}</sup>
      </span>
    `;
  }
}

customElements.define(
  'care-guide-product-recommendations',
  CareGuideProductRecommendations
);
